<template src="./OrkProductGallery.html"/>
<style lang='scss' scoped src="./OrkProductGallery.scss"/>

<script>

import {
  SfIcon,
  SfImage
} from '@storefront-ui/vue';

import icons from "@/utils/icons";
import OrkLoader from "@/components/Ork/OrkLoader";

import {Navigation, Pagination} from 'swiper'

import {SwiperCore, Swiper, SwiperSlide} from 'swiper-vue2'
import "swiper/swiper-bundle.css";
import {Video} from "@/models/video";

SwiperCore.use([Navigation, Pagination])

export default {
  name: 'OrkProductGallery',
  components: {
    SfImage,
    SfIcon,
    Swiper,
    SwiperSlide,
    OrkLoader

  },
  props: {
    loading: {default: true},
    gallery: {default: null}
  },
  data() {
    return {
      index: null,
      icons: icons,
      pagination: {
        clickable: true,
        renderBullet: (index, className) => {
          if (this.gallery[index] instanceof Video) {
            className+=` ${className}-video`
          }

          return `<span class="${className}"></span>`
        }
      }
    }
  },
  computed: {
    swiperSlides: {
      get() {
        return this.gallery
      }
    },
  },
  watch: {
    swiperSlides(newgal, oldgal) {
      this.$store.dispatch('setProductGallery', {gallery: newgal});
    }
  },
  mounted() {
    this.$store.dispatch('setProductGallery', {gallery: this.gallery});
  },
  beforeDestroy() {
    this.$store.dispatch('setIndexGallery', {index: null})
    this.$store.dispatch('setProductGallery', {gallery: []})
  },
  methods: {
    openLightBox(index) {
      this.$store.dispatch('setIndexGallery', {index: index})
    },

  }
};
</script>
